<template>
	<el-card>
		<div slot="header" class="header">
			<h3>{{ doctor.name }}</h3>
			<p>{{ doctor.email }}</p>
		</div>
	</el-card>
</template>

<script>
export default {
	name: 'provider-doctor',

	props: {
		doctor: {
			type: Object,
			required: true
		}
	}
}
</script>
